


































import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Getter } from "vuex-class";

@Component({
  computed: {
    ...mapGetters("admin", ["isEditingUser", "currentUserEmail"])
  }
})
export default class User extends Vue {
  @Getter("isAdminUser") isAdminUser?: boolean;
  @Getter("hasPost") hasPost?: boolean;
  @Getter("hasTopicPulse") hasTopicPulse?: boolean;
  @Getter("hasTopLine") hasTopLine?: boolean;
  @Getter("hasTether") hasTether?: boolean;
}
